<template>
<div class="header">
    Who produce songs for rapper?
</div>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>
.header {
  background: yellow;
  font-size: 2em;
  text-align: center;
  padding: 10px 0px;
  font-weight: bold;
  position: relative;
  top: 0px;
  left: 0px;
  min-width: 900px;
  font-family: Programme, Arial, sans-serif;
}
</style>